import {
  getNoticeTypeList,
  postNoticeType,
  updateNoticeType,
  deleteNoticeType,
} from "@/services/notice-type.service";

// initial state
const state = () => ({
  noticeTypeModel: {},
});

// mutations
const mutations = {
  setNoticeTypeModel(state, data) {
    state.noticeTypeModel = data;
  },
};

// actions
const actions = {
  //Duyuru Tipi Listesi
  async loadNoticeTypeList(vuexContext, co) {
    return await getNoticeTypeList(co).then((response) => {
      let data = response.data.data.items;

      data.map((item, index) => {
        item.index = index + 1;
      });
      return data;
    });
  },

  async postNoticeType(vuexContext, data) {
    return await postNoticeType(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateNoticeType(vuexContext, data) {
    return await updateNoticeType(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteNoticeType(vuexContext, noticeTypeId) {
    return await deleteNoticeType(noticeTypeId).then((response) => {
      let data = response;
      return data;
    });
  },

  addNoticeTypeModel(vuexContext, data) {
    vuexContext.commit("setNoticeTypeModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
